import { DataFilter } from '@siclop/kstone-vue'
import type { FieldType } from '@siclop/ksadmin-vue'

export class ComponentPropertyTypeFilter extends DataFilter {
  code?: string
  category?: string
  fieldType?: FieldType
  isSystem?: boolean

  constructor(data?: Partial<ComponentPropertyTypeFilter>) {
    super(data)
    if (data) {
      this.code = data.code
      this.category = data.category
      this.fieldType = data.fieldType
      this.isSystem = data.isSystem
    }
  }
}
